import * as React from 'react';
import { Button } from '@cian/ui-kit';

export interface ICommunicationActionButtonProps {
  onClick: () => void;
  children: React.ReactText | React.ReactText[];
  loading?: boolean;
  disabled?: boolean;
  testId?: string;
}

export const CommunicationActionButton: React.FC<ICommunicationActionButtonProps> = ({
  testId = 'communication-action',
  ...props
}) => {
  return <Button {...props} data-testid={testId} theme="fill_primary" size="M" fullWidth />;
};

CommunicationActionButton.displayName = 'CommunicationActionButton';
